import styled from '@emotion/styled';

export const ChatCard = styled.div<{
  padding: string;
  topMargin?: string;
}>`
  ${({ topMargin }) => topMargin && `margin-top: ${topMargin}px;`}
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${({ padding }) => padding};
  gap: 5px;
`;
